const ThumbnailAsset = (props) => {
    const asset = props.asset;
    const assetStyles = props.assetStyles;
    return (
        <img
            key={asset.id}
            src={process.env.REACT_APP_ZVB_URL + "assets/" + asset.filename_disk + "?format=webp"}
            alt={asset.alt_text}
            className={assetStyles}
        />
    )
}

export default ThumbnailAsset;